import i18n from "../../i18n";
import SectionModel from "../../models/sectionModel";
import { MARKETPLACE_RECURENT_REPORT, MARKETPLACE_RECURENT_REPORT_GET } from "../../store/reducers/restaurant/restaurant-actions";
import { CONTROL_TYPE, getRecurentReportTypes, getRecurrentReportFormatTypes, getRecurrentReportTypes, languages, MARKETPLACE_SETTINGS_MODEL } from "../../utils/enums";
import { createBreadcrumbModel } from "../createBreadcrumbModel";

export function createMarketplaceRecurentReportConfigEditSectionModel({ ...args }) {
    return new SectionModel({
        columns: [
            {
                isEditable: true,
                type: CONTROL_TYPE.sectionGroup,
                items: [
                    {
                        title: 'settings.orderingmenu.RECURENT_REPORT_ENABLED',
                        accessor: 'enabled',
                        isEditable: true,
                        isInline: true,
                        type: CONTROL_TYPE.switch,
                    },
                    {
                        title: 'settings.orderingmenu.RECURENT_REPORT_TYPE',
                        placeholder: i18n.t('settings.orderingmenu.RECURENT_REPORT_TYPE'),
                        accessor: 'recurrencyTypes',
                        connect: () => ({
                            values: getRecurrentReportTypes().map(obj => ({key: obj.value, value: obj.key})),
                        }),
                        isEditable: true,
                        type: CONTROL_TYPE.multiselect,
                    },
                    {
                        title: 'settings.orderingmenu.RECURENT_REPORT_LANGUAGE',
                        accessor: 'language',
                        connect: () => ({
                            values: [{key: null, value: '-'}].concat(languages()),
                        }),
                        isEditable: true,
                        type: CONTROL_TYPE.select,
                    },
                    {
                        title: 'settings.orderingmenu.RECURENT_REPORT_FORMAT_TYPES',
                        accessor: 'reportFormats',
                        connect: () => ({
                            values: getRecurrentReportFormatTypes().map(obj => ({key: obj.value, value: obj.key})),
                        }),
                        isEditable: true,
                        type: CONTROL_TYPE.multiselect,
                    },
                    {
                        title: 'settings.orderingmenu.RECURENT_REPORT_REPORTS',
                        accessor: 'reportTypes',
                        connect: () => ({
                            values: getRecurentReportTypes().map(obj => ({key: obj.value, value: obj.key})),
                        }),
                        isEditable: true,
                        type: CONTROL_TYPE.multiselect,
                    },
                ],
            },
            {
                title: 'settings.orderingmenu.RECIPIENTS',
                isEditable: true,
                type: CONTROL_TYPE.sectionGroup,
                items: [
                    {
                        title: 'settings.orderingmenu.RECIPIENTS',
                        accessor: 'recipients',
                        isEditable: true,
                        type: CONTROL_TYPE.addList,
                    },
                    {
                        accessor: 'recipients',
                        itemValue: {
                            key: 'key',
                            accessor: 'value',
                            isReadonly: true,
                        },
                        isReadonly: true,
                        isEditable: true,
                        isDraggable: true,
                        type: CONTROL_TYPE.listItem,
                    },
                ],
            },
        ],
        stayAfterSave: true,
        actionLoad: MARKETPLACE_RECURENT_REPORT_GET,
        actionName: MARKETPLACE_RECURENT_REPORT,
        initNewItemModel: item => {
            return item
                ? {...item, recipients: (item.recipients || []).map((r, index) => ({key: index, value: r}))}
                : {recipients: [], recurrencyTypes: [], enabled: false, language: null, reportFormats: [], reportTypes: []};
        },
        typeAction: args.typeAction,
        typeModel: MARKETPLACE_SETTINGS_MODEL.recurentReport,
        label: "settings.depotSettingsLabel.RECURENT_REPORT",
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'header.menu.MARKETPLACE_SETTINGS',
            }),
        ],
        mappingLambda: state => state.marketplace?.data?.recurentReport,
    });
}